const getRedirectOutputForm = ({ url, parameters }) => `
<form id="payment-provider-form" name="payment-provider-form" method="POST" action="${url}">
  ${Object.entries(parameters).map(([key, value]) => `
    <input type="hidden" name="${key}" value="${value}" />
  `).join("")}
</form>`.replace("\n", "");

export { getRedirectOutputForm };
